import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n'; // <--- เพิ่มบรรทัดนี้ครับ เพื่อให้ระบบภาษาเริ่มทำงานทันที
import { LanguageProvider } from './LanguageContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  {/* 2. ครอบแอปด้วย Provider */}
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>
);